player = {
    // Funkcia na riadenie zobrazovania tlacitka Loginu pomocou biometrie
    biometryButton(shouldBeAvailable) {
        try {
            if (shouldBeAvailable) {
                $("#unlockSB").hide();
                $("#biometryLogin").show();
            } else {
                $("#unlockSB").show();
                $("#biometryLogin").hide();
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zobrazenie inych moznosti loginu nez pomocou biometrie (pouziva sa v pripade neuspesneho prihlasenia pomocou biometrie)
    anotherLoginOptions() {
        try {
            // Skryje okno s prihlasenim
            player.hideBiometryLogin(true, true);
            // Skryje okno s informaciou o pokynoch k biometrickemu prihlaseniu
            modal.hideInfoModal();
            if (restriction = ticket.playerNotAllowedForBetting()) {
                modal.openVLCModal(restriction);
            } else if (profile.IsLoginRequired && profile.IsGamingClub) {
                if (!profile.VerifyCardActivation) {
                    modal.openVLCModal("NO_PLAYER");
                } else if (profile.IsRvoManualUnblockingAllowed) {
                    modal.openVLCModal("OPTIONS-3");
                } else {
                    modal.openVLCModal("OPTIONS-2");
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na skrytie BiometryLogin Preview
    hideBiometryLogin(disableCamera, fromUser) {
        try {
            if (disableCamera) {
                if (fromUser) {
                    communication.topScreen("biometryAutentification", { state: "hideBiometry", credentials: "biometry" });
                }
            }
            clearTimeout(rfs.faceDetectionTime);
            delete rfs.faceDetectionTime;
            $("#biometryLogin").removeClass("ui-disabled");
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia nastavuje timeout ukoncenia biometrie po urcitom case
    biometryLoginRfs() {
        try {
            clearTimeout(rfs.faceDetectionTime);
            delete rfs.faceDetectionTime;
            rfs.faceDetectionTime = setTimeout(function() {
                // Ak uplynie stanoveny cas a neprebehne prihlasenie
                stored.BiometryLoginPaused = true;
                communication.topScreen("biometryAutentification", { state: "failed" });
                communication.listenBottomScreen("biometryAutentification", JSON.stringify({ state: "failed" }));
                player.hideBiometryLogin(false);
            }, profile.Biometry.MaxFaceDetectionTime);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na obsluhu stlacenia tlacitka prihlasenia pomocou biometrie
    biometryLogin(credentials = "biometryLogin") {
        try {
            // Zrusim pripadne zobrazovanie streamu
            stream.streamEnd();
            // Pre ucel logovania: loginBtnTimeStamp - casova peniacka stlacenia login buttonu (windows local time)
            var biometryData = { loginBtnTimeStamp: new Date().getTime() };
            if (credentials === "privateAccess") {
                if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
                    return false;
                }
                biometryData.credentials = credentials;
                biometryData.playerID = stored.PlayerID;
            }
            $("#" + credentials).addClass("ui-disabled");
            // Zapnutie biometrie
            communication.topScreen(credentials, biometryData);
            // Zobrazenie informacnej hlasky - viac informacii na vrchnej obrazovke
            communication.listenBottomScreen("biometryAutentification", JSON.stringify({ state: "continuing", credentials: biometryData.credentials }));
        } catch (e) {
            main.createLog(2, credentials, "PLAYERID: " + stored.PlayerID + " CREDENTIAL: " + credentials + " ERROR: " + JSON.stringify(e) );
            return false;
        }
    },

    // Funkcia sluzi na opatovne spustenie overovania pomocou biometrie pri pauze
    biometryAgain(refreshBatchCount) {
        try {
            // Najskor odosle informaciu na topScreen o tom ze prebieha prihlasovanie
            // Pre ucel logovania: loginBtnTimeStamp - casova peniacka stlacenia login buttonu (windows local time)
            communication.topScreen("biometryAutentification", { state: "continuing", loginBtnTimeStamp: new Date().getTime() });
            communication.listenBottomScreen("biometryAutentification", JSON.stringify({ state: "continuing" }));
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // // Aktualizuje zostatok win currency pouzivatela (po prihlaseni na ticket sluzbu, pri storne tiketu - vola native)
    setWinCurrencyClientBalance(winCurrencyBalance, isFromNative) {
        try {
            winCurrencyBalance = Number(winCurrencyBalance) || 0;
            // Ak je isFromNative = false tak sa jedna o Number hodnotu winov prichadzajucu z ticket sluzby (prichadza decimal na 2 desatinne miesta)
            if (isFromNative) {
                // Z native prichadza string hodnota winov * 100 (neorezana hodnota s presnostou na 2 desatinne miesta)
                winCurrencyBalance = winCurrencyBalance / 100;
            }
            stored.WinCurrencyClientBalance = winCurrencyBalance;
            $(".ticket-header__item--win-currency .ticket-header__value").text(Number.isInteger(stored.WinCurrencyClientBalance) ? stored.WinCurrencyClientBalance : shared.floor2(stored.WinCurrencyClientBalance.toFixed(2)));
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Nastavenie vysky kreditu a prihlasenie na vernostny system
    setBalanceWithPlayerInfo(sbBalance, webBalance, webBalanceActive, moneyTransferReference, playerInfo, noShowModal) {
        try {
            var restriction, hasFreshLogin = false, hasFreshLogout = false, pendingOneTimeLogin = false;
            // Skryje okno s prihlasenim
            player.hideBiometryLogin(true);
            // Skryje okno s informaciou o pokynoch k biometrickemu prihlaseniu
            modal.hideInfoModal();
            // Simulovana akcia uzivatela
            main.userAction();

            if (playerInfo) playerInfo = JSON.parse(playerInfo);
            // Kontrola prihlasenia
            if ((playerInfo.playerID = parseInt(playerInfo.playerID)) && (stored.PlayerID != playerInfo.playerID)) {

                // Prihlasenie uzivatela na tiketovu sluzbu (freebet / bonification)
                ticket.ticketWsSetPlayer(playerInfo.playerID);

                // Prihlasenie uzivatela do vernostneho systemu
                stored.PlayerID = playerInfo.playerID;
                stored.IsVerified = (playerInfo.isVerified === "1");
                stored.IsGamblingProhibited = (playerInfo.isGamblingProhibited === "1");
                stored.IsInternalRvoError = (playerInfo.isInternalRvoError === "1");
                stored.Token = playerInfo.token;
                stored.ClubStats.validity = [];
                // Znacka pre GA aby login event neodchadzal pri kazdom refreshi balance
                hasFreshLogin = true;

                if (stored.PlayerID === profile.ManualVerifiedPlayerID) {
                    $("#ticketHeader").removeClass('client-logged');
                } else {
                    $("#ticketHeader").addClass(
                        `client-logged ${profile.IsWinCurrency ? "client-wincurrency" : "client-points"}`
                    );
                }

                // Vysklada objekt s nemodifikovanymi nastaveniami playera
                stored.UserSettings.Original = {
                    "playerLanguage": playerInfo.playerLanguage,
                    "favoriteSportLeague": playerInfo.favoriteSportLeague,
                    "favoriteEvent": playerInfo.favoriteEvent,
                    "allowedRateChangePlayer": playerInfo.allowedRateChangePlayer,
                    "notifySMS": playerInfo.notifySMS
                }
                if (profile.UserSettingsSections.length) {
                    $("#ticketHeader #userSettings").show();
                    // Vytvori kopiu player nastaveni
                    stored.UserSettings.Modified = Object.assign({}, stored.UserSettings.Original);

                    // Nastavi prostredie podla player nastaveni
                    player.playerSettingsModule.modifyUserSettingsObject("playerLanguage", playerInfo.playerLanguage, "setBalanceWithPlayerInfo");
                    ticket.allowedRateChange(playerInfo.allowedRateChangePlayer, false);

                    player.playerSettingsModule.userSettingCheckboxTrigger("favoriteSportLeague", (playerInfo.favoriteSportLeague === "1"), true);
                    player.playerSettingsModule.userSettingCheckboxTrigger("favoriteEvent", (playerInfo.favoriteEvent === "1"), true);

                    player.playerSettingsModule.userSettingCheckboxTrigger("notifySMS", (playerInfo.notifySMS === "1"), true);
                    player.playerSettingsModule.userSettingsPreserve(false, "setBalance");

                    // Moznost overenia tvare kamerou pre pristup k mojim udajom - cislo karty a PIN
                    if (profile.BiometryLogin && profile.UserSettingsSections.includes("myData") && stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID)) {
                        userData().prepare();
                    }
                }
                if (playerInfo.playerName) {
                    stored.PlayerName = playerInfo.playerName;
                    if (profile.IsLoginRequired) {
                        if (dialog.isOpen("universalModalDialog")) {
                            // Ak je otvorene univerzalne modalne okno s info o odomknuti sportboxu, skryje ho
                            main.closeDialog();
                        }
                        if (restriction = ticket.playerNotAllowedForBetting()) {
                            // Prihlaseny a zaroven neovereny player nema moznost betovat
                            if (restriction === "PLAYER_NOT_VERIFIED") {
                                modal.openVLCModal(restriction);
                            } else if (restriction === "PLAYER_INTERNAL_RVO_ERROR") {
                                // Nastala chyba pri volani RVO sluzby
                                modal.showErrObj(2, 5, {err1: texts.InternalRvoError, errType: "InternalRvoError"});
                            } else {
                                modal.showErrObj(2, 5, {err1: stored.PlayerName + "<br><br>" + texts.LogInMessage, errType: "LogInMessage"});
                            }
                        } else if (stored.PlayerID === profile.ManualVerifiedPlayerID) {
                            // Prihlaseny ma moznost betovat - anonymne tipovanie 'zelena karta'
                            modal.showErrObj(5, 5, {err1: texts.ModalVlcUnlockedLabel, err2: texts.LogInManualMessage, errType: "LogInManualMessage"});
                            // Nastavenie metody prihlasenia pre trackovanie do GA, osetrujem ak som uz hodnotu nastavil inde 
                            stored.loginMethod = stored.loginMethod || "zelena karta";
                        } else {
                            modal.showErrObj(5, 5, {err1: texts.ModalVlcUnlockedLabel, err2: stored.PlayerName + "<br>" + texts.LogInMessage, errType: "LogInMessage"});
                            // Nastavenie metody prihlasenia pre trackovanie do GA, osetrujem ak som uz hodnotu nastavil inde
                            stored.loginMethod = stored.loginMethod || "vernostna karta";
                        }
                    } else {
                        modal.showErrObj(2, 5, {err1: stored.PlayerName + "<br><br>" + texts.LogInMessage, errType: "LogInMessage"});
                    }
                } else {
                    modal.showErrObj(2, 5, {err1: texts.LogInMessage, errType: "LogInMessage"});
                }
                // zobrazenie modal o konci zatvaracich hodin v pripade ak sa prihlasi po zaciatku odpocitavania
                if (stored.PlayerID && rfs.ClosingTimeTimer) {
                    modal.toggleClosingTimeModal(true, sets.ClosingTimeTimeout);
                }
                if (profile.Favorite) {
                    stored.PlayerFavorite = new Object();
                    stored.PlayerFavorite[stored.favTypes.sport] = Array.isArray(playerInfo.playerFavorites.favouriteSports)? playerInfo.playerFavorites.favouriteSports: [];
                    stored.PlayerFavorite[stored.favTypes.leagueCup] = Array.isArray(playerInfo.playerFavorites.favouriteLeagues)? playerInfo.playerFavorites.favouriteLeagues: [];
                    stored.PlayerFavorite[stored.favTypes.event] = Array.isArray(playerInfo.playerFavorites.favouriteEvents)? playerInfo.playerFavorites.favouriteEvents: [];
                    stored.PlayerFavorite[stored.favTypes.chanceType] = Array.isArray(playerInfo.playerFavorites.favouriteChanceTypes)? playerInfo.playerFavorites.favouriteChanceTypes: [];

                    (stored.PlayerFavorite.sport.length || stored.PlayerFavorite.leagueCup.length? $("#userSettingsModal #favoriteSportLeagueDelete").show(): $("#userSettingsModal #favoriteSportLeagueDelete").hide());
                    (stored.PlayerFavorite.chanceType.length? $("#userSettingsModal #favoriteEventDelete").show(): $("#userSettingsModal #favoriteEventDelete").hide());
                }
                if (playerInfo.allowTransferMoneyToOnline !== undefined) {
                    stored.allowTransferMoneyToOnline = playerInfo.allowTransferMoneyToOnline * 1;
                }
            } else if (stored.PlayerID && !playerInfo.playerID) {
                // Odlisenie realneho odhlasenia od bezneho refreshu dat.
                hasFreshLogout = true;

                // zavretie modal o automatickom odhlaseni a schovanie notifikacie na hornej obrazovke
                modal.toggleAutoLogOffPlayerModal(false);

                // Odhlasenie uzivatela z tiketovej sluzby (freebet / bonification)
                ticket.ticketWsSetPlayer();
                modal.clearBonusModal();
                if (stored.FreebetModalActive || stored.JackpotModalActive) {
                    main.closeDialog();
                }
                // Odhlasenie
                delete stored.PlayerID;
                delete stored.PlayerName;
                delete stored.BonusPoints;
                delete stored.FreebetModalActive;
                delete stored.IsVerified;
                delete stored.IsGamblingProhibited;
                delete stored.IsInternalRvoError;
                delete stored.Token;
                delete stored.Freebets;
                delete stored.loginMethod;
                delete stored.allowTransferMoneyToOnline;
                stored.ClubStats.validity = [];
                stored.ticketOddsOrder = profile.TicketStatusOrderDefault;
                userData().remove();
                player.playerSettingsModule.clearUserSettings();
                player.playerTickets.clearMyTickets(true);
                player.incomeSourcesModule.clearIncomeSources();
                player.setWinCurrencyClientBalance(0);
                ticket.ticketPromoModule.freebetBonificationShowButtons(true);
                ticket.ticketWinCurrencyModule.deactivate();
                // Ziskanie fresh bonus listu (koli odstraneniu bonusov ktore patrili predchadzajucemu hracovi)
                more.menu.getBonusList(profile.TileInfo);
                $("#footer-sidebar #bonificationAvailable, #footer-sidebar #freebetAvailable").hide().find(".ui-btn-text span").empty();
                $("#freebetList #freebetButtons, #bonificationList #bonificationButtons").empty();
                $("#freebetButtons #freebetHeader").remove();
                $("#ticketHeader").removeAttr("class");
                $("#ticketHeader #userSettings").hide();
                $(".user-data-pin__button").removeClass("ui-disabled");
                // Nastavi default startPage stranku a zavrie otvorene okno
                if (!stream.isStreamPlaying) {
                    main.setPage(profile.startPage, true);
                }
                modal.showErrObj(2, 5, {err1: texts.LogOutMessage, errType: "LogOutMessage"});
            }

            if (restriction = ticket.playerNotAllowedForBetting()) {
                if (profile.BiometryLogin && profile.Biometry.BatchCount) {
                    player.biometryButton(true);
                } else {
                    player.biometryButton(false);
                }
            } else if (stored.PlayerID) {
                $("#unlockSB, #biometryLogin, #biometryRegister").hide();
            } else if (profile.BiometryLogin && profile.Biometry.BatchCount) {
                player.biometryButton(true);
            } else {
                $("#unlockSB, #biometryLogin").hide();
            }

            if (profile.BiometryOnboarding && !stored.PlayerID) {
                $("#biometryRegister").show();
            } else {
                $("#biometryRegister").hide();
            }

            // Nastavi balance cash / online
            var value, newBalance;
            if (webBalanceActive == "0") {
                $("#ticketHeader").removeClass("client-web-balance-active");
                $(".ticket-header__balance .ticket-header__item--balance").attr("onmousedown", "ticket.calc('all')");
                webBalanceActive = false;
            }
            if (stored.WebBalanceActive = Boolean(webBalanceActive)) {
                $(".ticket-header__item--account .ticket-header__value").text(texts.HeaderAccountOnline);
                $(".ticket-header__balance .ticket-header__item--balance").attr("onmousedown", "ChangeMoneySource();");
                $("#ticketHeader").addClass("client-web-balance-active");

                value = webBalance;
            } else {
                stored.WebBalanceActive = null;
                // Neaktivny web balance
                if (webBalance !== "0") {
                    $("#ticketHeader").addClass("client-web-balance-active");
                    $(".ticket-header__balance .ticket-header__item--balance").attr("onmousedown", "ChangeMoneySource();");
                }
                $(".ticket-header__item--account .ticket-header__value").text(texts.HeaderAccountCash);
                value = sbBalance;
            }

            // Nastavi ClientID online uctu klienta
            if (moneyTransferReference) {
                stored.MoneyTransferReference = moneyTransferReference;
            } else {
                stored.MoneyTransferReference = null;
            }

            // Nastavi hodnotu balance
            if (!profile.Currency) profile.Currency = "";
            if (!(value = parseInt(value)) && value <= 0) {
                newBalance = "0,00 " + profile.Currency;
                stored.Balance = 0;
            } else if (value = value / 100) {
                newBalance = shared.floor2(value, 1) + " " + profile.Currency;
                if (stored.Balance < value && !rfs.approve && !+noShowModal) {
                    // Testovanie ci nieje otvorene quickbet modalne okno, ak nieje otvorene, tak notifikuje o stave balancu
                    // noShowModal - 1 poziadavka na nezobrazenie okna, 0 - poziadavka na zobrazenie okna so zmenenym balancom
                    if (!($.mobile.activePage.is("#quickBetWrapper") && stored.TokenQuickBet)) {
                        // Počas otvoreneho quickbet okna sa notifikácia vyvoláva a nastavuje inde hint: texts.QuickBetNotificationWin
                        modal.showErrObj(2, 5, {err1: texts.BalanceIncreased + " " + newBalance, errType: "LogInMessage"});
                    }
                }
                stored.Balance = value;
                // Ak je otvorene quickbet okno
                if ($.mobile.activePage.is("#quickBetWrapper") && stored.TokenQuickBet) {
                    // Posle na QB iframe info o zmene balancu, iframe notifikuje quickbet backend ktory vyziada aktualizovany balance z doxxbet bakckendu
                    document.getElementById("quickBetIframe").contentWindow.postMessage("request_user_balance", profile.QuickBets.UrlControls);
                    clearTimeout(rfs.myTickets);
                    rfs.myTickets = setTimeout(function() {
                        if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                            player.playerTickets.myTicketsFilter(false, true);
                        } else {
                            delete cache.MyTickets;
                        }
                    }, 1000);
                }
            }
            // Aktualizuje zobrazeny balance
            $(".ticket-header__balance .ticket-header__item--balance").text(newBalance);

            var headerCashBack = texts.HeaderCashBack.replace(/ /g, '<br>');
            // Nastavi tlactiko vratit hotovost pri nulovom konte, rozhoduje sa podla sbBalance
            if (stored.PlayerID === profile.ManualVerifiedPlayerID) {
                // Nastavi tlactiko na vyber / odhlasenie prihlaseneho hraca, manualne overeneny hrac - bez karty (Odhlasit sa)
                $("#moneyBack").removeClass("ui-disabled").find(".header-right__button-label").html(texts.HeaderLogoutManualVerifiedBR);
            } else if (sbBalance && sbBalance != "0" && webBalanceActive != "1") {
                if (stored.PlayerID && sbBalance > "0") {
                    // Nastavi tlactiko na vyber / odhlasenie prihlaseneho hraca prebehne v ramci vyberu
                    $("#moneyBack").removeClass("ui-disabled").find(".header-right__button-label").html(texts.HeaderCashBackLogoutBR);
                } else {
                    // Hrac je neprihlaseny a ma kladny balance ktory nieje webovy
                    $("#moneyBack").removeClass("ui-disabled").find(".header-right__button-label").html(headerCashBack);
                }
            } else if (stored.PlayerID) {
                // Hrac je prihlaseny - ma moznost odhlasit kartu (nulovy balance alebo aktivny web balance)
                $("#moneyBack").removeClass("ui-disabled").find(".header-right__button-label").html(texts.HeaderLogoutBR);
            } else {
                // Hrac je neprihlaseny - tlacitko zablokovane
                $("#moneyBack").addClass("ui-disabled").find(".header-right__button-label").html(headerCashBack);
            }

            // Ak je zobrazene jedno z okien (more, language, terms) tak sa zatvori okno a nasledne vynuluje deposit
            dialog.isOpen("more") && dialog.close("more");
            dialog.isOpen("modalLanguage") && dialog.close("modalLanguage");
            dialog.isOpen("doxxbetTerms") && dialog.close("doxxbetTerms");
            dialog.isOpen("doxxbetClub") && dialog.close("doxxbetClub");
            dialog.isOpen("bonuses") && dialog.close("bonuses");

            if (!ticket.balance()) {
                // Ak je zadany balance a ziadne z uvedenych okien nie je otvorene tak sa vynuluje deposit
                ticket.calc("clear", true);

            } else if (!rfs.approve) {
                // Ak sa nejedna o freebet a deposit je vyssi ako novy balance tak deposit nastavi na mozne maximum
                if (stored.OverallTotalBet > ticket.balance() && !stored.FreebetID && !stored.BonificationID) {
                    // Ak je novy ballance nizsi ako je minBet pre bonifikaciu tak ju zrusi
                    if (stored.BetAll) {
                        ticket.calc("all", true);
                    } else {
                        ticket.checkSum();
                    }

                } else if (stored.BetAll) {
                    // Ak je vo faze podavania a chce vsadit vsetko tak sa mu pri zvyseni sumy nastavi max vklad
                    ticket.calc("all", true);

                } else if (stored.OverallTotalBet < ticket.balance()) {
                    // Ak je novy balance vyssi ako bet tak zrusi oznacenie max vkladu
                    $(".bet-all .ui-btn, #calcComma .ui-btn").removeClass("ui-btn-active");
                    document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                }
            }

            // Nastavi pocet bodov prihlasenemu hracovi a skontroluje moznosti bonifikacie
            if (stored.PlayerID) {
                if (!(stored.BonusPoints = parseInt(playerInfo.bonusPoints))) stored.BonusPoints = 0;
                $(".ticket-header__item--points .ticket-header__value").text(stored.BonusPoints);
                // Skontroluje moznosti bonifikacie
                if (!rfs.approve) ticket.ticketPromoModule.checkBonificationButtons();
            }


            ticket.updateDepositToggle();

            // Kratkodoby hint pre klasifikaciu typu prihlasenia do user-scoped dimenzie.
            const one_time_login_hint_timeout_ms = 300000; // Kratky timeout (5 min), aby sa OTL hint nepreniesol na neskorsi bezny login.
            pendingOneTimeLogin = Boolean(rfs?.identityContext?.pendingOneTimeLogin);
            if (pendingOneTimeLogin && rfs?.identityContext?.pendingAt && ((Date.now() - rfs.identityContext.pendingAt) > one_time_login_hint_timeout_ms)) {
                pendingOneTimeLogin = false;
                rfs.identityContext.pendingOneTimeLogin = false;
                rfs.identityContext.pendingAt = null;
            }

            communication.dataTrackModule.track.playerIdentity({
                hasFreshLogin: hasFreshLogin,
                hasFreshLogout: hasFreshLogout,
                playerId: stored.PlayerID,
                reportedPlayerId: playerInfo?.playerID,
                loginMethod: stored?.loginMethod,
                pendingOneTimeLogin: pendingOneTimeLogin
            });

            // Po realnom prechode identity (login/logout) uz hint netreba, inak by skreslil dalsiu klasifikaciu hraca.
            if ((hasFreshLogin || hasFreshLogout) && rfs?.identityContext) {
                rfs.identityContext.pendingOneTimeLogin = false;
                rfs.identityContext.pendingAt = null;
            }

            return stored.Balance;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Tlacitko moneyBack na vratenie hotovosti
    moneyBack(user) {
        try {

            // Uzivatelska akcia
            if (user) {
                if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu

                main.closeDialog();
                if (!stored.PlayerID) {
                    // Neprihlaseny hrac - manualny vyber formou tlace kreditneho listka
                    try {
                        ActionWithdrawal();
                        modal.showErrObj(2, 5, {err1: texts.ReturnCash, errType: "ReturnCash"});
                        return true;
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                        $("#moneyBack").removeClass("ui-disabled");
                        return false;
                    }
                } else {
                    // Prihlaseny hrac - manualne odhlasenie a vyber cez nativeApp formular
                    try {
                        LogOffPlayer();
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                        $("#moneyBack").removeClass("ui-disabled");
                        return false;
                    }
                }

            } else if (!stored.PlayerID) {

                // Neprihlaseny hrac s nenulovym kontom - automaticky vyber formou tlace kreditneho listka
                try {
                    if (stored.Balance) {
                        ActionWithdrawal();
                        modal.showErrObj(2, 5, {err1: texts.ReturnCash, errType: "ReturnCash"});
                    }
                    return true;
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }

            } else {

                // Prihlaseny hrac - automaticke odhlasenie a pripadny vyber formou tlace kreditneho listka
                try {
                    if (stored.Balance) {
                        AutoLogOffPlayer();
                        modal.showErrObj(2, 5, {err1: texts.ReturnCash, errType: "ReturnCash"});
                    } else {
                        AutoLogOffPlayer();
                    }
                    return true;
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            if (!stored.Balance) $("#moneyBack").removeClass("ui-disabled");
            main.closeDialog();
            return false;
        }
    },

    // Funkcia sluzi na prepinanie zobrazenia menu, Môj účet (Nastavenia, Moje údaje)
    userSettingsMenuSwitch(content) {
        try {
            userData().hide();
            // Zvyrazni pozadovanu menu polozku a zobrazi prislusny obsah
            $("#userSettingsModal")
                .find("#userSettingsMenu .user-settings-btn")?.removeClass("flat-highlighted-header")
                .filter("." + content)?.addClass("flat-highlighted-header").end().end()
                .find("#userSettingsContent .content")?.hide().filter("." + content + "-content")?.show();
        } catch (e) {
            closeDialog();
            modal.showErrObj(1, 5, { err1: texts.ConnectionErr, errType: "ConnectionErr" });
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    toggleAutoPinHide(sec) {
        var translation = '';
        var secondsText = function (sec) {
            switch (sec) {
                case 0:
                    return texts.ModalAutoLogOffPlayer_seconds[0];
                case 1:
                    return texts.ModalAutoLogOffPlayer_seconds[1];
                case 2:
                case 3:
                case 4:
                    return texts.ModalAutoLogOffPlayer_seconds[2];
                default:
                    return texts.ModalAutoLogOffPlayer_seconds[3];
            }
        };
        var hidePinText = function(sec) {
            translation = texts.MyDataPinInfo.replace('{#}', sec).replace('{s}', secondsText(sec)).split('{}');
            return translation[0];
        };
        return hidePinText(sec);
    },

    onboarding: {
        inProgress: false,
        playerIsViewingLegalDocs: false,
        init: function () {
            player.onboarding.inProgress = true;
            player.onboarding.playerIsViewingLegalDocs = false;
            profile.ConsoleLog && console.warn("player.onboarding.init() - onboarding in progress");
        },
        show: function (oneTimeLogin) {
            try {
                // inicializacia onboarding procesu
                player.onboarding.init();
                rfs.identityContext = rfs.identityContext || {};
                if (oneTimeLogin) {
                    // Pri jednorazovom odomknuti si drzim hint pre naslednu klasifikaciu identity v GA.
                    rfs.identityContext.pendingOneTimeLogin = true;
                    rfs.identityContext.pendingAt = Date.now();
                }
                // trekovanie do GA, ze sa spustil onboarding proces
                var onboardingTrackPayload = {
                    state: "init",
                    nextStep: null,
                    info: oneTimeLogin ? "OneTimeLogin" : null,
                    errorKey: null,
                    initiator: "webApp"
                };
                communication.listenBottomScreen("biometryOnboardingTrack", JSON.stringify(onboardingTrackPayload));
                // Schovam otvorene dialogove okna
                main.closeDialog();
                // Zrusim pripadne zobrazovanie streamu
                stream.streamEnd();
                // Zobrazim onboarding obrazovku
                profile.ConsoleLog && console.warn("player.onboarding.show() - onboarding screen shown");
                // cakam na zatvorenie vlc modal
                setTimeout(function() {
                    try {
                        if (rfs?.watcher) {
                            clearTimeout(rfs.watcher);
                            rfs.watcher = null;
                        }
                        if (oneTimeLogin) {
                            BiometryOneTimeLogin();
                        } else {
                            BiometryOnboarding();
                        }
                    } catch(e) {
                        player.onboarding.stop();
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments), e);
                        return false;
                    }
                }, 500);
            } catch (e) {
                player.onboarding.stop();
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments), e);
                return false;
            }
        },
        stop: function () {
            if (rfs?.watcher) {
                clearTimeout(rfs.watcher);
                rfs.watcher = null;
            }
            player.onboarding.inProgress = false;
            player.onboarding.playerIsViewingLegalDocs = false;
            profile.ConsoleLog && console.warn("player.onboarding.stop() - onboarding finished");
        }
    }
};

function userData() {
    var myDataShowPinElement = $("#myData");
    // Funkcia zobrazuje/skryva cislo vernostnej karty a PIN
    function triggerUserData () {
        // Kontrola ci je hrac prihlaseny
        if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
            main.closeDialog();
            return false;
        }
        if (myDataShowPinElement.hasClass("show-pin")) {
            myDataShowPinElement.removeClass("show-pin");
            userData().hide();
        } else {
            // Zablokovanie tlacitka na dalsie stlacenie
            $(".user-data-pin__button").addClass("ui-disabled");
            // Spustenie overenia pomocou biometrie
            biometryLogin('privateAccess');
        }
    }
    // Funkcia sluzi na zobrazenie hracskych udajov a PIN-u
    function showUserData() {
        var timeoutPIN = profile.Biometry.TimeoutPin/1000;
        myDataShowPinElement.addClass("show-pin");
        rfs.HidePINPlayer = setInterval(function() {
            if (timeoutPIN <= 0) {
                userData().hide();
            } else {
                // Zobrazenie zostavajuceho casu do skrytia PIN-u
                myDataShowPinElement.find(".user-data-pin__info").first().text(player.toggleAutoPinHide(timeoutPIN));
                timeoutPIN--;
            }
        }, 1000);
        // opatovne opotvorenie dialogoveho okna s informaciou o PIN-e lebo je zatvorene po hlaskach biometrickeho overenia
        dialog.open({
            id: "userSettingsModal",
            persistent: true,
            parseJQM: false,
            // prvotne zobrazenie casu do skrytia PIN-u lebo inak by bola 1s pauza kym sa spusti interval a zobrazi sa cas
            onOpen: function() { myDataShowPinElement.find(".user-data-pin__info").first().text(player.toggleAutoPinHide(timeoutPIN)); }
        });
    }

    // Funkcia sluzi na skrytie hracskych udajov a PIN-u
    function hideUserData() {
        myDataShowPinElement?.find(".user-data-pin__info").first().text("");
        myDataShowPinElement?.removeClass("show-pin");
        clearInterval(rfs.HidePINPlayer);
        rfs.HidePINPlayer = false;
    }

    // Funkcia sluzi na ziskanie player dat
    function fetchUserData(url, data, timeout = 15000) {
        return new Promise(function (resolve, reject) {
            // Validate inputs
            if (typeof url !== "string") {
                return reject(new Error(`Invalid URL: ${JSON.stringify(url)}`));
            }
            if (typeof data !== "object") {
                return reject(new Error(`Invalid data: ${JSON.stringify(data)}`));
            }

            var timeoutUserDataPromise = new Promise(function (_, reject) {
                setTimeout(function () {
                    return reject(new Error("Request timed out"));
                }, timeout);
            });

            var fetchUserDataPromise = fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Cache-Control": "no-cache, no-store",
                    "Authorization": "Bearer " + stored.Token
                },
                body: JSON.stringify(data)
            });

            Promise.race([fetchUserDataPromise, timeoutUserDataPromise])
                .then(function (response) {
                    if (!response?.ok) {
                        throw new Error(`Response statusText: ${response.statusText}`);
                    }
                    return response?.json();
                })
                .then(function (data) {
                    if (data?.playerID !== stored.PlayerID) {
                        throw new Error(`Invalid data.playerID: ${data.playerID}, expected stored.PlayerID: ${stored.PlayerID}`);
                    }
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    // Funkcia na ziskanie player dat na zobrazenie v sekcii Moje udaje
    function prepareUserData() {
        try {
            userData().remove();
            fetchUserData(url.centralSB + "/onboarding/player-data",
                {
                    playerID: stored.PlayerID,
                    sportBoxID: stored.SBID,
                }
            ).then(function(data) {
                // Naplnenie udajov do sekcie Moje udaje
                $("#userSettingsContent")
                    .find("#myDataName").text(data.firstName + " " + data.lastName).end()
                    .find("#myDataCard").attr("my-data-card", data.cardID).end()
                    .find("#myDataPin").attr("my-data-pin", data.pin);
                $("#userSettingsModal #userSettingsMyData").show();
            }).catch(function(error) {
                // Oznacenie prvej polozky v menu
                // Nie cez mousedown trigger ktory zavola userAction (ktory spusta signalR)
                player.userSettingsMenuSwitch('settings');
                // Schova v menu sekciu s menom, cislom karty a pinom
                userData().remove();
                $("#userSettingsModal #userSettingsMyData").hide();
                main.createLog(2, "prepareUserData", "# AJAX FAILED: " + error);
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            });
            return true;
        } catch (e) {
            userData().remove();
            main.createLog(2, "prepareUserData", "ERROR: " + e?.message);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Vymazanie player dat (neukladaju sa do stored premennej, su len v DOM)
    function removeUserData() {
            $("#userSettingsContent")
            .find("#myDataName").text("").end()
            .find("#myDataCard").attr("my-data-card", "").end()
            .find("#myDataPin").attr("my-data-pin", "").end()
            .find("#myData").removeClass("show-pin");
    }

    // Funkcie potrebujeme volat z root scope
    return {
        trigger: triggerUserData,
        show: showUserData,
        hide: hideUserData,
        prepare: prepareUserData,
        remove: removeUserData
    };
}
